<template>
  <div>
     <van-popup v-model ="showPop" position="bottom">
        <van-datetime-picker
            v-model="date"
            type="date"
            title="选择年月日"
            :formatter="$compUtil.formatterDatePicker"
            @confirm="confirm"
            v-if="pickerType == 'date'"
        />
        <van-datetime-picker
            v-model="date"
            type="year-month"
            title="选择年月"
            :formatter="$compUtil.formatterDatePicker"
            @confirm="confirm"
            v-if="pickerType == 'yearMonth'"
        />
    </van-popup>
  </div>
</template>

<script>
import { stringify } from 'querystring';


export default {
  name: 'DateSelectDialog',
  props:{
    pickerType:{
      type:String,
      default:"date"
    }
  },
  components: {
  },
  computed: {
  },
  data() {
    return {
        showPop:false,
        date:new Date()
    };
  },
  mounted(){
    
  },
  methods: {
    open(date){
        this.showPop = true;
        this.date = date || new Date();
    },
    confirm(){
      var d = new Date(this.date);
      d.setHours(d.getHours()+8)
      this.showPop = false;
      this.$emit('confirm',d);
    }
  }
};
</script>

<style lang="less" scoped>
</style>
